import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-requestor-dialog',
  templateUrl: './add-requestor-dialog.component.html',
  styleUrls: ['./add-requestor-dialog.component.scss'],
  standalone: false,
})
export class AddRequestorDialogComponent {
  requestorForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AddRequestorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.requestorForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      department: [''],
      title: ['']
    });
  }

  // Save the new requestor
  saveRequestor(): void {
    if (this.requestorForm.valid) {
      const newRequestor = {
        name: this.requestorForm.value.name.toLowerCase().trim(),
        email: this.requestorForm.value.email.toLowerCase().trim(),
        department: this.requestorForm.value.department?.trim() || '',
        title: this.requestorForm.value.title?.trim() || ''
      };
      this.dialogRef.close(newRequestor);
    }
  }

  // Close the dialog without saving
  cancel(): void {
    this.dialogRef.close(null);
  }

  // Get form control error messages
  getErrorMessage(fieldName: string): string {
    const control = this.requestorForm.get(fieldName);
    
    if (control?.hasError('required')) {
      return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is required`;
    }
    
    if (control?.hasError('email')) {
      return 'Please enter a valid email address';
    }
    
    if (control?.hasError('minlength')) {
      return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be at least 2 characters`;
    }
    
    return '';
  }
}
